export const COUPON_EXPERIENCE = {
  ust: 'sweepstakes',
};
